export const ru = {
    "user": {
        "profile": "Профиль",
        "logout": "Выйти"
    },
    "sidebar": {
        "citCentre": "Ситуационный центр",
        "citCentreHelloFirst": "Добро пожаловать в панель администрировая ситуационного центра!",
        "citCentreHelloSecond": "Для начала работ вы можете выбрать одну из категорий в боковой панели.",
        "administratingSystem": "Система администрирования",
        "masterDataManagementSubSystem": "Подсистема управления мастер-данными",
        "dynamicFactorsInputSubSystem": "Подсистема ввода динамических показателей",
        "handbooksManagementSubSystem": "Подсистема управления классификаторами",
        "actualIndicators": "Фактические показатели",
        "industries": "Сферы/отрасли",
        "plannedFactorsAccountingSubSystem": "Подсистема учёта плановых показателей",
        "publicDataManagementSubSystem": "Подсистема управления открытыми данными",
        "publication": "Публикация"
    },
    "warnings": {
        "readOnlyHandbook": "Данный классификатор недоступен для модификации. Из функционала доступен только просмотр.",
        "noIndustrySelectedForEditing": "Не выбрана сфера/отрасль для модификации!",
        "waitUntilIndustriesTreeIsLoaded": "Дождитесь загрузки древовидного списка.",
        "youReEditingIndustrySphere": "Вы редактируете сферу",
        "youReEditingIndustryBranch": "Вы редактируете отрасль",
        "youReCreatingIndustrySphere": "Вы создаете сферу",
        "youReCreatingIndustryBranch": "Вы создаете отрасль",
        "addedIndustryWillBeChildFor": "Добавляемая отрасль будет дочерней для",
        "saved": "Сохранено",
        "industryElementHasBeenSaved": "Данные элемента индустрии успешно обновлены!",
        "handbookItemHasBeenUpdated": "Значение элемента классификатора успешно обновлено!",
        "handbookItemHasBeenCreated": "Новый элемент классификатора успешно добавлен!",
        "indicatorInformationIsSaved": "Данные индикатора успешно обновлены!",
        "indicatorHasBeenCreated": "Индикатор успешно создан!",
        "factorHasBeenCreated": "Новый показатель успешно добавлен!",
        "factorHasBeenUpdated": "Значение показателя успешно обновлено!"
    },
    "actions": {
        "selectOneIndustryToEditFromTheLeftList": "Выберите сферу/отрасль из списка слева.",
        "addNewHandbookItem": "Добавить запись классификатора",
        "addNewChildIndustryBranch": "Добавить дочернюю отрасль",
        "addNewIndustrySphere": "Добавить новую сферу",
        "addNewIndicator": "Добавить новый индикатор",
        "creationOfANewIndicator": "Создание нового индикатора",
        "creationOfANIndicator": "Создание индикатора",
        "managingHandbooks": "Управление классификаторами",
        "others": "Другие",
        "import": "Импорт",
        "editing": "Редактирование",
        "indicatorEditing": "Редактирование индикатора",
        "industryInformationEditing": "Редактирование информации о Сфере/отрасли",
        "allAmount": "Всего",
        "selected": "Выбрано",
        "makeChanges": "Внести изменения",
        "saveChanges": "Применить изменения",
        "revertChanges": "Отменить изменения",
        "selectActivityType": "Выберите тип активности",
        "finishCreation": "Завершить создание",
        "importFromExcel": "Импорт из Excel",
        "importFromCSV": "Импорт из CSV",
        "selectPeriodicity": "Выберите периодичность",
        "selectMeasureUnitShortened": "Выберите ед. изм.",
        "selectInformationSourceShortened": "Выберите ист. инф.",
        "selectSourceSystemShortened": "Выберите сис.-ист.",
        "addFactor": "Добавить показатель",
        "getLink": "Получить ссылку",
        "viewRaw": "Просмотреть raw",
        "copyThisIntoClipboard": "Скопируйте в буфер обмена"
    },
    "common": {
        "name": "Наименование",
        "names": "Наименования",
        "alternativeName": "Альтернативное наименование",
        "comment": "Комментарий",
        "type": "Тип",
        "factors": "Показатели",
        "handbooks": "Справочники",
        "industrySphereOrBranch": "Сфера / Отрасль",
        "taldauIdentifier": "Идентификатор Талдау",
        "activityType": "Тип активности",
        "periodicity": "Периодичность",
        "inRussian": "на русском",
        "inEnglish": "на английском",
        "inKazakh": "на казахском",
        "inRussianLanguage": "на русском языке",
        "inEnglishLanguage": "на английском языке",
        "inKazakhLanguage": "на казахском языке",
        "industrySphere": "Сфера",
        "industryBranch": "Отрасль",
        "minValue": "Минимальное значение",
        "maxValue": "Максимальное значение",
        "measureUnit": "Единица измерения",
        "values": "Значения",
        "value": "Значение",
        "linkedDocuments": "Связанные документы",
        "region": "Регион",
        "district": "Район",
        "districtOrRegion": "Район/Регион",
        "plan": "План",
        "period": "Период",
        "user": "Пользователь",
        "anyValue": "Любое значение",
        "available": "Доступно",
        "notAvailable": "Недоступно",
        "advancedSearchParameters": "Дополнительные параметры поиска",
        "yes": "Да",
        "no": "Нет",
        "systemIdentifierContainment": "Содержание системного идентификатора"
    },
    "loadings": {
        "loadingIndustriesTree": "Загрузка древовидного списка сфер и отраслей. Пожалуйста, подождите ...",
        "loadingIndustryInformation": "Загрузка данных по выбранной сфере/отрасли"
    },
    "indicators": {
        "listOfFactorsForSelectedIndicator": "Список показателей выбранного индикатора",
        "dynamicFactorsInputByPeriodicity": "Ввод динамических показателей по периодичности",
        "masterDataManagement": "Управление мастер-данными",
        "informationAboutIndicator": "Информация об индикаторе",
        "editingInformationAboutThisIndicator": "Изменение информации об индикаторе",
        "logicalRange": "Логический диапазон",
        "informationSource": "Источник информации",
        "sourceSystem": "Система-источник",
        "thisIndicatorIsBeing": "Этот индикатор является",
        "factorsOfThisIndicatorAreVerified": "Данные показателей этого индикатора являются проверенными/верифицированными",
        "factorsOfThisIndicatorAreNotVerified": "Данные показателей этого индикатора не являются проверенными/верифицированными",
        "beingPositive": "позитивным",
        "beingNegative": "негативным",
        "beingDepricated": "устаревшим",
        "beingPublic": "публичным",
        "factorsBeingRaisedIsAGoodSign": "Рост значений показателей является хорошим признаком",
        "factorsBeingRaisedIsABadSign": "Увеличение значений показателей имеет ухудшающий оттенок",
        "plannedValueIsAvailableForFactorsOfThisIndicator": "Для показателей этого индикатора доступно плановое значение",
        "divisionByRegions": "Распределение по районам",
        "noDivisionByRegions": "Распределения по районам нет",
        "divisionByRegionsDescription": "При выборе данного переключателя, значения показателей должны быть привязаны к определенному району",
        "plannedValueAvailable": "Плановое значение доступно",
        "noPlannedValueAvailable": "Нет планового значения",
        "plannedValueAvailableDescription": "При выборе данного переключателя, значения показателей могут иметь плановое значение",
        "linkedDocumentsSelectionDescription": "Индикатор может реализовывать определенные документы. Из списка ниже можно выбрать необходимые документы для связи с индикатором.",
        "positive": "Позитивный",
        "negative": "Негативный",
        "positiveDescription": "При выборе данного переключателя, индикатор будет иметь позитивное значение.",
        "verified": "Верифицирован",
        "notVerified": "Непроверен",
        "verifiedDescription": "При выборе данного переключателя, показатели данного индикатора будут иметь приоритет проверенного источника.",
        "obsolete": "Устарел",
        "actual": "Актуален",
        "obsoleteDescription": "При выборе данного переключателя, индикатор помечается как устаревший.",
        "flags": "Флаги",
        "factorsOfIndicator": "Показатели индикатора",
        "plannedFactorsAccounting": "Учёт плановых показателей",
        "plannedValue": "Плановое значение",
        "dataVerificationStatus": "Статус верифицированности данных",
        "dataFactorsPositivity": "Позитивность данных",
        "dataPublicity": "Публичность данных",
        "public": "Публичный",
        "private": "Приватный",
        "publicDescription": "При выборе данного переключателя, индикатор помечается как публичный. Данные его показателей могут быть доступны для отображения в представлениях с публичным доступом.",
        "publicOrOpenDataPublication": "Публикация открытых/публичных данных"
    },
    "industrySelectionOverlay": {
        "p1": "В этом древовидном списке",
        "p2": "Аналитические",
        "p3": "сферы и отрасли помечены значком",
        "p4": ", а",
        "p5": "Оперативные",
        "p6": " - значком",
        "p7": "Корневые элементы дерева всегда являются",
        "p8": "Сферами",
        "p9": ", а их дочерние элементы - ",
        "p10": "Отраслями"
    },
    "changeLang": {
        "changeLanguage": "Изменить язык",
        "russian": "Русский",
        "english": "Английский",
        "kazakh": "Казахский"
    }
};